import { ChangeEvent, FC } from 'react';
import {
  HStack,
  Checkbox,
  Center,
  VStack,
  Box,
  Text,
  Image,
} from '@chakra-ui/react';

import { extractName } from '../utils';
import { TeamMember } from '../models';

export const UserData: FC<{
  roleName: TeamMember['role']['name'];
  firstName: TeamMember['firstName'];
  lastName: TeamMember['lastName'];
  pictureUrl?: TeamMember['profilePictureThumbnailURL'];
  hasCheckbox?: boolean;
  onChangeCheckbox?: (e: ChangeEvent<HTMLInputElement>) => void;
}> = ({
  firstName,
  lastName,
  pictureUrl,
  roleName,
  hasCheckbox = false,
  onChangeCheckbox,
}) => {
  return (
    <HStack>
      {hasCheckbox && (
        <Checkbox colorScheme="orange" onChange={onChangeCheckbox} />
      )}
      <Box w="10" h="10" bg="custom_blue.1" borderRadius="full">
        {pictureUrl ? (
          <Image src={pictureUrl} borderRadius="full" />
        ) : (
          <Center h="full" color="white" textTransform="capitalize">
            {extractName(`${firstName} ${lastName}`)}
          </Center>
        )}
      </Box>
      <VStack align="flex-start">
        <Text color="custom_blue.1" fontWeight="semibold" fontSize="sm">
          {firstName} {lastName}
        </Text>
        <Text color="custom_blue.1" fontSize="xs">
          {roleName}
        </Text>
      </VStack>
    </HStack>
  );
};
